module.exports = __webpack_public_path__ + "img/logo-vertical-1.9bcfc5df.svg";